module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec04_pc_26df64592dc4bcd6e9d00b11e416a003.jpg";